// extracted by mini-css-extract-plugin
export default {"pageWrap":"ud-z","fullWidth":"vd-z","heading":"wd-z","fullBleed":"xd-z","hidden":"yd-z"};